<template lang="pug">
    v-card
        crud-create-button(
            :action="submitCreateCostCenter"
            v-if="$can('CREATE_COST_CENTER')"
            )
        model-data-table(
            :service="service" 
            :headers="headers"
            :filters="filters"
            no-search
            @remove="submitDelete($event.item.id)"
            @detail="submitShowCostCenterDetail($event.item)"
            ref="refDTCostCenterList"
            remind-key='cost-center-list'
            no-data-text='Sin centros de costo.'
            no-search-box
            showItem
            :showButton="() => $can('VIEW_DETAIL_COST_CENTER')"
            :deleteButton="() => $can('DELETE_COST_CENTER')"
            )
        dialog-create-cost-center(ref="refDialogCreateCostCenter" @success="refreshDT")
        dialog-show-cost-center(ref="refDialogShowCostCenter" :costCenterObj="costCenterObj" @success="refreshDT")
</template>

<script>
//-
import { mapActions, mapState } from 'vuex'
import { CrudCreateButton } from '@/components/reusable_components'
import ModelDataTable from '@/components/reusable_components/next/ModelDataTable'
import HeadersCostCenter from './HeadersCostCenter'
import DialogCreateCostCenter from './dialog/DialogCreateCostCenter'
import DialogShowCostCenter from './dialog/DialogShowCostCenter'
import { deleteCostCenter } from '@/services/api/costCenter'
import MdlCostCenter from '@/models/Accounting/AccCostCenter'
import CostCenterFilters from './AccCostCenterFilters'
//-
export default {
    name: 'list-cost-center',
    // props: {},
    data: function() {
        return {
            filters: CostCenterFilters,
            headers: HeadersCostCenter,
            service: MdlCostCenter,
            costCenterObj: {},
            deleteId: 0,
        }
    },
    computed: {
        ...mapState('SnackbarModalModule', {
            responseConfirm: 'responseConfirm',
        }),
    },
    methods: {
        // -- UI Modification
        submitCreateCostCenter: function() {
            this.$refs.refDialogCreateCostCenter.open = true
        },
        submitShowCostCenterDetail: function(event) {
            this.costCenterObj = event
            this.$refs.refDialogShowCostCenter.open = true
        },
        submitDelete: function(event) {
            this.resetSnackbarState()
            this.setMessageConfirmSnack('Eliminar')
            let payload = this.fillSnack(
                'warning',
                '¿Desea eliminar centro de costo?',
                ''
            )
            this.initSnackbar(payload)
            this.deleteId = event
        },
        // -- Data fetching
        getCostCenter: function() {
            const url = process.env.VUE_APP_API_ROUTE.concat(`/acc_cost_center`)
        },
        // -- Data handling and transformations
        // -- Validations and Error handling
        refreshDT: function() {
            this.$refs.refDTCostCenterList.refresh()
        },
        // -- Other functions
        // -- Vuex mappings
        ...mapActions('MenuesModule', {
            setTitleTopBar: 'setTitleTopBar',
        }),
        ...mapActions('SnackbarModalModule', {
            initSnackbar: 'initSnackbar',
            hideSnack: 'hideSnack',
            resetSnackbarState: 'resetSnackbarState',
            setMessageConfirmSnack: 'setMessageConfirmSnack',
        }),
    },
    watch: {
        async responseConfirm(val) {
            //-
            if (val === 'Eliminar') {
                this.resetSnackbarState()
                let response = await deleteCostCenter(this.deleteId)
                //-
                if (response.status == 'success') {
                    let payload = this.fillSnack(
                        'success',
                        'Centro de costo eliminado',
                        ''
                    )
                    this.initSnackbar(payload)
                    this.$refs.refDTCostCenterList.refresh()
                } else {
                    let payload = this.fillSnack(
                        'error',
                        'Error',
                        response.error
                    )
                    this.initSnackbar(payload)
                }
            }
        },
    },
    components: {
        'crud-create-button': CrudCreateButton,
        'model-data-table': ModelDataTable,
        'dialog-create-cost-center': DialogCreateCostCenter,
        'dialog-show-cost-center': DialogShowCostCenter,
    },
    // mixins: [],
    // filters: {},
    // -- Lifecycle Methods
    mounted: function() {
        this.setTitleTopBar('Centro de costos')
        this.getCostCenter()
    },
    beforeRouteEnter(to, from, next) {
        next(ctx => {
            if (!ctx.$can('VIEW_ALL_COST_CENTER')) ctx.$router.push('/')
        })
    },
    // -- End Lifecycle Methods
}
</script>

<style lang="scss">
</style>